import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, BoxProps, InternalStandardProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledListIconsWrapper = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "-20px",
});

const StyledIconVideo = styled(FontAwesomeIcon)(({ theme }) => ({
    fontSize: "25px",
    color: theme.palette.primary.main,
}));

const StyledIconCourse = styled(FontAwesomeIcon)(({ theme }) => ({
    fontSize: "30px",
    color: theme.palette.primary.main,
}));

const StyledIconAudio = styled(FontAwesomeIcon)(({ theme }) => ({
    fontSize: "27px",
    color: theme.palette.primary.main,
}));

export const DashboardListItemIcon = (props: DashboardListItemIconProps) => {
    const { contentType } = props;
    return (
        <StyledListIconsWrapper>
            {contentType?.toLowerCase() === "video" && (
                <StyledIconVideo icon={["fas", "video"]} />
            )}
            {contentType?.toLowerCase() === "course" && (
                <StyledIconCourse icon={["fas", "award"]} />
            )}
            {contentType?.toLowerCase() === "audio" && (
                <StyledIconAudio icon={["fas", "music"]} />
            )}
        </StyledListIconsWrapper>
    );
};

interface DashboardListItemIconProps extends InternalStandardProps<BoxProps> {
    contentType: string;
}
